export const CURRENT_USER = 'current_user';